/* import design posters here*/
import item22 from '../../assets/designs/beauty-in-tragedy.png'
import item29 from '../../assets/designs/art-of-living.png'
import item6 from '../../assets/designs/harrys-house.png'
import item11 from '../../assets/designs/glass-world.png'
import item4 from '../../assets/designs/neighbourhood.png'
import item7 from '../../assets/designs/black-eyed-peas.png'
import item8 from '../../assets/designs/citizen-concert.png'
import item27 from '../../assets/designs/citizen-gradient.png'
import item19 from '../../assets/designs/famous-actor.png'
import item13 from '../../assets/designs/mat-kerekes.png'
import item16 from '../../assets/designs/nova-album.png'
import item23 from '../../assets/designs/turnover.png'
import item12 from '../../assets/designs/copacetic.png'
import item28 from '../../assets/designs/dont-love-you.png'
import item24 from '../../assets/designs/emotional-sickness.png'
import item10 from '../../assets/designs/human.png'
import item17 from '../../assets/designs/when-together.png'
import item26 from '../../assets/designs/myself-in-the-way.png'
import item9 from '../../assets/designs/mktour.png'
import item25 from '../../assets/designs/anything-goes.png'
import item2 from '../../assets/designs/spinning.png'
import item33 from '../../assets/designs/YYLAS.png'
import item39 from '../../assets/designs/glitterer.png'
import item42 from '../../assets/designs/beauty-in-tragedy.png'

/* images for other art posters */
import item21 from '../../assets/designs/dont-look.png'
import item5 from '../../assets/designs/dull-knife.png'
import item15 from '../../assets/designs/identity-crisis.png'
import item32 from '../../assets/designs/its-okay.png'
import item31 from '../../assets/designs/jelly.png'
import item30 from '../../assets/designs/waldo.png'
import item20 from '../../assets/designs/what-it-is.png'
import item14 from '../../assets/designs/disco.png'
import item3 from '../../assets/designs/layers.png'
import item1 from '../../assets/designs/tlou.png'
import item18 from '../../assets/designs/exhausted.png'
import item34 from '../../assets/designs/bees.png'
import item36 from '../../assets/designs/blu-grad.png'
import item37 from '../../assets/designs/disco-var.png'
import item45 from '../../assets/designs/red-grad.png'
import item47 from '../../assets/designs/mine.png'

/* images for eecs */
import item48 from '../../assets/designs/eecs/bytes.png'
import item49 from '../../assets/designs/eecs/scholars-grad.png'
import item50 from '../../assets/designs/eecs/cs-advising.png'
import item51 from '../../assets/designs/eecs/feast.png'
import item52 from '../../assets/designs/eecs/eecs-banner.png'

/* images for misc */
import item53 from '../../assets/designs/other-proj/settings.png'
import item54 from '../../assets/designs/other-proj/calculator.png'
import item55 from '../../assets/designs/other-proj/sign-up.png'


const musicImageData = [
/* first row */
  {
    imgSrc: item33,
    imgText: "Concept poster inspired by Mat Kerekes' album 'You Look Like A Stranger.",
  },
  {
    imgSrc: item17,
    imgText: "Concept poster inspired by The 1975's 'When We Are Together.'",
  },
  {
    imgSrc: item25,
    imgText: "Concept poster inspired by Arctic Monkeys' 'Sculptures of Anything Goes.'",
  },

/* second row */
  {
    imgSrc: item6,
    imgText: "Concept poster inspired by Harry Styles' 'Late Night Talking.'",
  },
  {
    imgSrc: item9,
    imgText: "Concept tour poster for Mat Kerekes' Fall 2022 US Tour.",
  },
  {
    imgSrc: item4,
    imgText: "Concept poster inspired by The Neighbourhood's 'You Get Me So High.'",
  },

/* third row */
  {
    imgSrc: item26,
    imgText: "Concept poster inspired by Turnover's 'Myself in the Way.'",
  },
  {
    imgSrc: item24,
    imgText: "Concept poster inspired by Phoebe Bridgers' 'Emotional Motion Sickness.'",
  },
  {
    imgSrc: item28,
    imgText: "Concept poster inspired by Citizen's 'I Don't Love You.'",
  },

/* fourth row */
  {
    imgSrc: item16,
    imgText: "Concept poster inspired by Mat Kereke's album, Nova.",
  },
  {
    imgSrc: item10,
    imgText: "Concept poster inspired by The 1975's 'Human Too.",
  },
  {
    imgSrc: item11,
    imgText: "Concept poster inspired by Citizen's 'Glass World.'",
  },

/* fifth row */
  {
    imgSrc: item19,
    imgText: "Concept poster inspired by Mat Kereke's 'Look, I'm a Famous Actor.'",
  },
  {
    imgSrc: item13,
    imgText: 'Concept poster of Mat Kerekes, 2022.',
  },
  {
    imgSrc: item2,
    imgText: "Concept poster inspired by Balance and Composure's 'Spinning.'",
  },

/* sixth row */
  {
    imgSrc: item29,
    imgText: "Concept poster inspired by Mat Kereke's 'The Art of Living.'",
  },
  {
    imgSrc: item12,
    imgText: "Concept poster inspired by Knuckle Puck's 'Untitled.'",
  },
  {
    imgSrc: item7,
    imgText: "Concept poster inspired by The Black Eyed Peas.",
  },
      
/* seventh row */
  {
    imgSrc: item42,
    imgText: "Concept poster inspired by Citizen's, 'Edge of the World.'",
  },
  {
    imgSrc: item23,
    imgText: "Concept faux receipt inspired by Turnover's album, Good Nature.",
  },
  {
    imgSrc: item39,
    imgText: "Concept poster inspired by Glitterers' album, as well as the concert I attended in 2021",
  },

/* eighth row */
  {
    imgSrc: item8,
    imgText: "Concept poster inspired by Citizen's LIYGW Tour. I saw them on Nov 24, 2021. Pictures taken by me.",
  },
  {
    imgSrc: item27,
    imgText: "Concept poster of Citizen, 2021. Type by me.",
  },
];

const artImageData = [
/* first row */
  {
    imgSrc: item1,
    imgText: "Concept poster for 'The Last of Us' TV Series; based on Naughty Dog's 2013 Video Game.",
  },
  {
    imgSrc: item3,
    imgText: "Life Has Too Many Layers, 2022. (@lucidlu.psd on IG)",
  },
  {
    imgSrc: item21,
    imgText: "Don't Look, 2022. (@lucidlu.psd on IG)",
  },

/* second row */
  {
    imgSrc: item36,
    imgText: "Blue Gradient, 2023. (@lucidlu.psd on IG)",
  },
  {
    imgSrc: item30,
    imgText: "Where's Waldo, 2022. (@lucidlu.psd on IG)",
  },
  {
    imgSrc: item45,
    imgText: "Red Gradient, 2023. (@lucidlu.psd on IG)",
  },

/* third row */
  {
    imgSrc: item5,
    imgText: "Dull Knife, 2021. (@lucidlu.psd on IG)",
  },
  {
    imgSrc: item14,
    imgText: "Funk It Up, 2022. (@lucidlu.psd on IG)",
  },
  {
    imgSrc: item20,
    imgText: "It Is What It Is, 2021. (@lucidlu.psd on IG)",
  },

/* fourth row */
  {
    imgSrc: item15,
    imgText: "Ruminating Thoughts, 2022. (@lucidlu.psd on IG)",
  },
  
  {
    imgSrc: item18,
    imgText: "I'm Exhausted, 2022. (@lucidlu.psd on IG)",
  },
  {
    imgSrc: item31,
    imgText: "Jellyfish, 2022. (@lucidlu.psd on IG)",
  },

/* fifth row */
  {
    imgSrc: item37,
    imgText: "Disco Variant, 2022. (@lucidlu.psd on IG)",
  },
  {
    imgSrc: item34,
    imgText: "Bees, 2022. ((@lucidlu.psd on IG)",
  },
    {
    imgSrc: item32,
    imgText: "It's Okay, 2022. (@lucidlu.psd on IG)",
  },

/* sixth row */

  
  {
    imgSrc: item47,
    imgText: "You are forever mine, 2021. (@lucidlu.psd on IG)",
  }
];

const eecsImageData = [
  {
    imgSrc: item49,
    imgText: "A flyer made for a CS Scholars graduation event.",
  },
  {
    imgSrc: item50,
    imgText: "A flyer made noting the CS Advising hours for the semester.",
  },
  {
    imgSrc: item51,
    imgText: "A flyer for a Pre-Thanksgiving feast hosted by EECS CS Scholars.",
  },
  {
    imgSrc: item48,
    imgText: "A flyer for an event 'Bytes and Gather' hosted by EECS CS Scholars.",
  },
  {
    imgSrc: item52,
    imgText: "Banner for the weekly EECS Undergraduate Newsletter.",
  },

];

const miscImageData = [
  {
    imgSrc: item53,
    imgText: "Settings page design concept for an app.",
  },
  {
    imgSrc: item54,
    imgText: "Concept sreens for a calculator app.",
  },
  {
    imgSrc: item55,
    imgText: "Sign up screen concept I made for an dog walking app.",
  },
];

export {
  musicImageData,
  artImageData,
  eecsImageData,
  miscImageData
};
